module.exports = __webpack_public_path__ + "static/media/Lens.55d440b3.svg";